import React, { useState } from "react";
import CommonAccountPanelView from "presentational/account/CommonAccountPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import { isValidInput } from "lib/textFilter";
import { withStore } from "store/storeHandler";
import TXT from "presentational/common/multinational/TXT";
import Service from "lib/service-amp";
import PropTypes from "prop-types";

ForgotPwConfirmPanel.propTypes = {
  email: PropTypes.string.isRequired,
  onConfirmBtnClick: PropTypes.func.isRequired
};

function ForgotPwConfirmPanel(props) {
  const { email, onConfirmBtnClick, AppErrorActions, NoticeModalActions } =
    props;
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const displayNotice = (type, input) => {
    let content;
    switch (type) {
      case "pwNotExist":
        content = <TXT name="msg_enterNewPassword" />;
        break;
      case "codeNotExist":
        content = (
          <TXT name="msg_enterVerificationCode" input={{ email: input }} />
        );
        break;
      case "twoPwNotSame":
        content = <TXT name="msg_matchBothPassword" />;
        break;
      case "incorrectPwFormat":
        content = <TXT name="msg_pwFormatGuide" />;
        break;
      case "invalidCode":
        content = <TXT name="msg_enterVorrectVeriCode" />;
        break;
      case "success":
        content = <TXT name="msg_passwordChanged" />;
        break;
      case "defaultError":
      default:
        content = <TXT name="msg_commonNetworkError" />;
        break;
    }
    NoticeModalActions.openModal({ content });
  };

  const handleTextChange = (type, value) => {
    switch (type) {
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmNewPassword":
        setConfirmNewPassword(value);
        break;
      case "confirmationCode":
        setConfirmationCode(value);
        break;
      default:
        break;
    }
  };

  const handleSubmitBtnClick = async () => {
    if (!newPassword || !confirmNewPassword) {
      displayNotice("pwNotExist");
      return null;
    } else if (!confirmationCode) {
      displayNotice("codeNotExist", email);
      return null;
    } else if (newPassword !== confirmNewPassword) {
      displayNotice("twoPwNotSame");
      return null;
    } else if (!isValidInput("password", newPassword.trim())) {
      displayNotice("incorrectPwFormat");
      return null;
    }

    if (isLoading) return null;
    await setIsLoading(true);

    const { code, res } = await Service.confirmForgotPassword(
      email,
      confirmationCode,
      newPassword.trim()
    );

    switch (code) {
      case "ok":
        displayNotice("success");
        onConfirmBtnClick();
        break;
      case "InvalidParameterException":
      case "CodeMismatchException":
        displayNotice("invalidCode");
        break;
      case "error":
      default:
        AppErrorActions.setSafeAppError(Error(res));
        displayNotice("defaultError");
        break;
    }

    setIsLoading(false);
  };

  return (
    <div>
      <CommonAccountPanelView
        title={<TXT name="titlePanel_resetPassword" />}
        textElement={["newPassword", "confirmNewPassword", "confirmationCode"]}
        onInputValueChange={handleTextChange}
        firstBtnText={<TXT name="btnPanel_resetPassword" />}
        onFirstBtnClick={handleSubmitBtnClick}
        emailForHelperTxt={email}
      />
      <LoadingModalView open={isLoading} />
    </div>
  );
}

export default withStore({
  dispatchMap: ["appError", "noticeModal"]
})(ForgotPwConfirmPanel);
